'use es6';

import PropertyOptionRecord from 'customer-data-objects/property/PropertyOptionRecord';
import http from 'hub-http/clients/apiClient';
import { List, Map as ImmutableMap } from 'immutable';
import DSFieldRecord from '../../../filterQueryFormat/DSFieldRecord/DSFieldRecord';
import { isCustomBehavioralEventObjectTypeId } from '../../../filterQueryFormat/ObjectTypeId';
import { AdapterCache } from '../requestCaches/adaptersCache';
import createDSAdapter from './createDSAdapter';
export const fetchedDataCache = new AdapterCache();
export const processedDataCache = new AdapterCache();
const parseOptions = options => {
  if (!Array.isArray(options)) {
    return null;
  }
  return options.reduce((acc, option) => {
    if (!option.hidden) {
      return acc.push(PropertyOptionRecord({
        label: option.label,
        value: option.value
      }));
    }
    return acc;
  }, List());
};
const makeCustomBehavioralEventPropertiesAdapter = () => {
  function isAssetFamilySupported(assetFamily) {
    return isCustomBehavioralEventObjectTypeId(assetFamily);
  }
  function getFetcherFromProps() {
    return http.get;
  }
  function fetch(httpClient, _, eventTypeId) {
    const url = `properties/v4/${eventTypeId}`;
    if (fetchedDataCache.get(url)) {
      return fetchedDataCache.get(url);
    }
    const request = httpClient(url);
    fetchedDataCache.set(url, request);
    return request;
  }
  function updater(properties, _, assetFamily) {
    const cacheKey = `EVENT_PROPERTIES_${assetFamily}`;
    if (processedDataCache.get(cacheKey)) {
      return processedDataCache.get(cacheKey);
    }
    const formatted = properties.reduce((acc, item) => {
      const {
        label,
        name,
        type,
        options,
        externalOptions,
        externalOptionsReferenceType
      } = item.property;
      return acc.set(item.property.name, DSFieldRecord(Object.assign({
        label,
        type,
        name,
        options: parseOptions(options)
      }, externalOptions && {
        externalOptions
      }, externalOptionsReferenceType && {
        externalOptionsReferenceType
      })));
    }, ImmutableMap());
    processedDataCache.set(cacheKey, formatted);
    return formatted;
  }
  return createDSAdapter({
    fetch,
    getFetcherFromProps,
    isAssetFamilySupported,
    updater
  });
};
const customBehavioralEventPropertiesAdapter = makeCustomBehavioralEventPropertiesAdapter();
export default customBehavioralEventPropertiesAdapter;